
    (function(){
      const root      = document.getElementById('sc-template--19166064476202__highlight_carousel_white_9QGCkL');
      if (!root) return;
      const viewport  = root.querySelector('.sc-viewport');
      const panelsEl  = root.querySelector('.sc-panels');
      const panels    = Array.from(root.querySelectorAll('.sc-panel'));
      const titleEl   = root.querySelector('.sc-title');
      const subtitle  = root.querySelector('.sc-subtitle');
      const radios    = Array.from(root.querySelectorAll('input[name="slide-template--19166064476202__highlight_carousel_white_9QGCkL"]'));
      const nextBtn   = root.querySelector('.sc-next');
      const autoplayMs= 4000;
      const autoplay  = true;
      let timer; const lifecycle = new AbortController(); const listen = (target, event, handler, options = {}) => target.addEventListener(event, handler, { ...options, signal: lifecycle.signal }); const removal = new MutationObserver(() => { if (!root.isConnected) { clearInterval(timer); clearTimeout(root.__rsz); lifecycle.abort(); if (typeof io !== 'undefined') io.disconnect(); removal.disconnect(); } }); removal.observe(document.body, {childList:true,subtree:true});
      let visible = false;

      panelsEl.addEventListener('dragstart', e => e.preventDefault());
      root.querySelectorAll('img, picture, source').forEach(el => el.setAttribute('draggable','false'));

      const idx   = () => radios.findIndex(r => r.checked);
      const gap   = () => parseFloat(getComputedStyle(panelsEl).gap || '0') || 0;
      const slideW= () => viewport.clientWidth;
      const baseX = () => -(idx() * (slideW() + gap()));
      const setX  = (x = baseX()) => panelsEl.style.transform = `translateX(${x}px)`;

      function markActive(i){ panels.forEach((p,n)=>p.classList.toggle('sc-active', n===i)); }

      function swapText(el, newText){
        if (el.textContent === newText) return;
        el.classList.remove('sc-enter');
        el.classList.add('sc-leave');
        el.addEventListener('animationend', function h(){
          el.removeEventListener('animationend', h);
          el.textContent = newText;
          el.classList.remove('sc-leave');
          void el.offsetWidth;
          el.classList.add('sc-enter');
        }, {once:true});
      }
      function updateTitle(i = idx()){
        const t = panels[i]?.dataset.title || '';
        swapText(titleEl, t);
      }
      function updateSubtitle(i = idx()){
        const t = panels[i]?.dataset.subtitle || '';
        swapText(subtitle, t);
      }

      function goTo(i){
        if (!radios.length) return;
        i = (i + radios.length) % radios.length;
        radios[i].checked = true;
        setX(); markActive(i); updateTitle(i); updateSubtitle(i);
      }
      const next = () => goTo(idx()+1);
      const prev = () => goTo(idx()-1);

      function stopAutoplay(addPausedClass = true){
        clearInterval(timer);
        if (addPausedClass) root.classList.add('sc-paused');
      }
      function startAutoplay(){
        stopAutoplay(false);
        if (!autoplay || !visible) { root.classList.add('sc-paused'); return; }
        root.classList.remove('sc-paused');
        timer = setInterval(next, autoplayMs);
      }
      function maybeStartAutoplay(){
        if (autoplay && visible) startAutoplay(); else stopAutoplay(true);
      }

      const io = new IntersectionObserver((entries)=>{
        entries.forEach(entry=>{
          visible = entry.isIntersecting && entry.intersectionRatio >= 0.6;
          maybeStartAutoplay();
        });
      }, { threshold: [0, 0.25, 0.6, 1] });
      io.observe(root);

      listen(window, 'load', ()=>{ setX(); markActive(0); updateTitle(0); updateSubtitle(0); titleEl.classList.add('sc-enter'); subtitle.classList.add('sc-enter'); });
      listen(window, 'resize', ()=>{ clearTimeout(root.__rsz); root.__rsz=setTimeout(()=>{ setX(); },100); });

      radios.forEach((r,i)=> r.addEventListener('change', ()=>{ goTo(i); maybeStartAutoplay(); }));

      if (nextBtn) nextBtn.addEventListener('click', ()=>{ next(); maybeStartAutoplay(); });

      let dragging=false, startX=0, startY=0, startT=0, lock=null, startOffset=0;

      function onDown(e){
        if (e.buttons !== undefined && e.buttons !== 1 && e.pointerType === 'mouse') return;
        dragging=true; lock=null;
        startX=e.clientX; startY=e.clientY; startT=performance.now();
        startOffset=baseX();
        panelsEl.classList.add('sc-dragging');
        viewport.classList.add('is-dragging');
        stopAutoplay();
        panelsEl.setPointerCapture?.(e.pointerId);
      }
      function onMove(e){
        if (!dragging) return;
        const dx=e.clientX-startX, dy=e.clientY-startY;
        if (lock==null && (Math.abs(dx)>8 || Math.abs(dy)>8)) lock = Math.abs(dx)>=Math.abs(dy)?'x':'y';
        if (lock==='y'){ onUp(e,true); return; }
        if (lock==='x'){ panelsEl.style.transform = `translateX(${startOffset + dx}px)`; e.preventDefault?.(); }
      }
      function onUp(e, cancel=false){
        if (!dragging) return;
        dragging=false;
        panelsEl.classList.remove('sc-dragging');
        viewport.classList.remove('is-dragging');
        panelsEl.releasePointerCapture?.(e.pointerId);
        if (cancel){ setX(); maybeStartAutoplay(); return; }

        const dx=e.clientX-startX, dt=Math.max(1, performance.now()-startT), vx=dx/dt;
        const threshold = slideW()*0.15, speed=0.35;
        if (dx<=-threshold || vx<=-speed) next();
        else if (dx>=threshold || vx>=speed) prev();
        else setX();

        maybeStartAutoplay();
      }
      viewport.addEventListener('pointerdown', onDown, {passive:true});
      listen(window, 'pointermove', onMove, {passive:false});
      listen(window, 'pointerup', onUp, {passive:true});
      listen(window, 'pointercancel', e=>onUp(e,true), {passive:true});
    })();
